import { type Event } from 'hb-react/shared/apps/Events';

const MEETING_END_REASON_TITLES = {
  '0': (eventName: string) =>
    s__('Events|You are no longer connected to the event "%{eventName}".').i__({
      eventName,
    }),
  '1': (eventName: string) =>
    s__('Events|The event "%{eventName}" has ended.').i__({ eventName }),
  '2': (eventName: string) =>
    s__('Events|You have left the event "%{eventName}".').i__({ eventName }),
  '3': (eventName: string) =>
    s__('Events|You have left the event "%{eventName}".').i__({ eventName }),
  '4': (eventName: string) =>
    s__('Events|You have left the event "%{eventName}".').i__({ eventName }),
  '5': (_eventName: string) =>
    s__('Events|You have switched to another device.'),
  '6': (eventName: string) =>
    s__('Events|You have been disconnected from the event "%{eventName}".').i__(
      { eventName },
    ),
  '7': (eventName: string) =>
    s__('Events|You have been disconnected from the event "%{eventName}".').i__(
      { eventName },
    ),
  '8': (eventName: string) =>
    s__('Events|You have left the event "%{eventName}".').i__({ eventName }),
} as const;

export const getZoomCompletedTitle = (
  meetingEndReason: string,
  event: Event,
) => {
  const titleFunction =
    MEETING_END_REASON_TITLES[
      meetingEndReason as keyof typeof MEETING_END_REASON_TITLES
    ];

  if (titleFunction) {
    return titleFunction(event.title);
  }

  // Fallback for unknown reasons
  return s__(
    'Events|You are no longer connected to the event "%{eventName}".',
  ).i__({ eventName: event.title });
};
